/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsDetail } from './GoodsDetail';
import {
    GoodsDetailFromJSON,
    GoodsDetailFromJSONTyped,
    GoodsDetailToJSON,
    GoodsDetailToJSONTyped,
} from './GoodsDetail';
import type { CancelGoodsItem } from './CancelGoodsItem';
import {
    CancelGoodsItemFromJSON,
    CancelGoodsItemFromJSONTyped,
    CancelGoodsItemToJSON,
    CancelGoodsItemToJSONTyped,
} from './CancelGoodsItem';
import type { AdditionalServiceItem } from './AdditionalServiceItem';
import {
    AdditionalServiceItemFromJSON,
    AdditionalServiceItemFromJSONTyped,
    AdditionalServiceItemToJSON,
    AdditionalServiceItemToJSONTyped,
} from './AdditionalServiceItem';
import type { CouponPayItem } from './CouponPayItem';
import {
    CouponPayItemFromJSON,
    CouponPayItemFromJSONTyped,
    CouponPayItemToJSON,
    CouponPayItemToJSONTyped,
} from './CouponPayItem';

/**
 * 
 * @export
 * @interface BillCreateReqVo
 */
export interface BillCreateReqVo {
    /**
     * 账单类型：1-代买账单，2-代买取消手续费账单，3-转运国际配送费账单，4-代买退款账单，5-中国退货账单，6-中国库存入库检查账单，7-火箭订单账单，8-库存出库账单，9-韩国库存入库账单，10-韩国有误订单处理账单，11-韩国本地购买火箭或库存退货账单，12-返送账单，13-人民币钱包充值账单，14-人民币钱包提款账单，15-韩币钱包充值账单，16-韩币钱包提款账单，17-仓库保管费，18-管理员充值，19-管理员扣款，20-代买取消退款账单，21-代买退款手续费账单，22-无数据废弃费用账单，23-追加费用账单，24-库存出库退款账单，25-出库取消手续费账单，26-原运单退货账单，27-橙火保管费账单，28-公共退款账单，29-人民币钱包充值账单(CN)，30-韩币钱包充值账单(CN)，31-韩币钱包提款账单(CN)，32-管理员充值(CN)，33-管理员扣款(CN)，34-仓库保管费(CN)
     * @type {number}
     * @memberof BillCreateReqVo
     */
    billType: number;
    /**
     * 订单编码
     * @type {string}
     * @memberof BillCreateReqVo
     */
    orderCode?: string;
    /**
     * 预检时的订单状态（由precheck接口返回，保存时回传用于一致性校验）
     * @type {number}
     * @memberof BillCreateReqVo
     */
    orderStatus?: number;
    /**
     * 预检时的订单修改时间（由precheck接口返回，保存时回传用于乐观锁校验）
     * @type {string}
     * @memberof BillCreateReqVo
     */
    orderUpdateTime?: string;
    /**
     * 预检时的商品数量（由precheck接口返回，保存时回传用于商品一致性校验）
     * @type {number}
     * @memberof BillCreateReqVo
     */
    goodsCount?: number;
    /**
     * 预检返回的订单及商品快照标识；代买取消保存须回传原始标识
     * @type {string}
     * @memberof BillCreateReqVo
     */
    orderDataToken?: string;
    /**
     * 汇率（非必填，不传则自动获取）
     * @type {number}
     * @memberof BillCreateReqVo
     */
    exchangeRate?: number;
    /**
     * 计算货物运费的单位：1-kg，2-lbs，3-cbm，4-cm
     * @type {number}
     * @memberof BillCreateReqVo
     */
    applyUnit?: number;
    /**
     * 适用货物运费的值（所有箱子之和，根据applyUnit确定单位）
     * @type {number}
     * @memberof BillCreateReqVo
     */
    applyValue?: number;
    /**
     * 货物收费总金额，默认为0
     * @type {number}
     * @memberof BillCreateReqVo
     */
    totalGoodsAmount?: number;
    /**
     * 附加服务总金额，默认为0
     * @type {number}
     * @memberof BillCreateReqVo
     */
    totalAdditionalServiceAmount?: number;
    /**
     * 钱包转账总金额，默认为0
     * @type {number}
     * @memberof BillCreateReqVo
     */
    totalTransferAmount?: number;
    /**
     * 账单总金额 = totalGoodsAmount + totalAdditionalServiceAmount + totalTransferAmount
     * @type {number}
     * @memberof BillCreateReqVo
     */
    totalAmount: number;
    /**
     * 卡号
     * @type {string}
     * @memberof BillCreateReqVo
     */
    cardNumber?: string;
    /**
     * 卡类型：1-储蓄卡，2-信用卡
     * @type {number}
     * @memberof BillCreateReqVo
     */
    cardType?: number;
    /**
     * 货币代码
     * @type {string}
     * @memberof BillCreateReqVo
     */
    currencyCode: string;
    /**
     * 用户ID
     * @type {number}
     * @memberof BillCreateReqVo
     */
    userId: number;
    /**
     * 账单状态：0-未支付，1-待汇款，2-已支付，3-已取消
     * @type {number}
     * @memberof BillCreateReqVo
     */
    status: number;
    /**
     * 卡所在银行名称
     * @type {string}
     * @memberof BillCreateReqVo
     */
    cardBankName?: string;
    /**
     * 持卡人姓名
     * @type {string}
     * @memberof BillCreateReqVo
     */
    cardHolderName?: string;
    /**
     * 备注
     * @type {string}
     * @memberof BillCreateReqVo
     */
    remark?: string;
    /**
     * 创建账单的管理员ID，只有管理员主动给用户创建账单时才有值
     * @type {number}
     * @memberof BillCreateReqVo
     */
    createStaffId?: number;
    /**
     * 是否发送短信：1-发送，0-不发送
     * @type {number}
     * @memberof BillCreateReqVo
     */
    sendSms?: number;
    /**
     * 货物明细列表（非钱包充值提款类型时传入，可多条）
     * @type {Array<GoodsDetail>}
     * @memberof BillCreateReqVo
     */
    goodsDetailList?: Array<GoodsDetail>;
    /**
     * 附加服务明细列表（非钱包充值提款类型时传入，可多条）
     * @type {Array<AdditionalServiceItem>}
     * @memberof BillCreateReqVo
     */
    additionalServiceList?: Array<AdditionalServiceItem>;
    /**
     * 明细通用内容（JSON字符串）
     * @type {string}
     * @memberof BillCreateReqVo
     */
    detailContent?: string;
    /**
     * 账单关联实体ID（按账单类型不同区分，如无数据商品编号）
     * @type {number}
     * @memberof BillCreateReqVo
     */
    targetId?: number;
    /**
     * 仓库ID（非必填，订单创建账单时传订单current_warehouse_id；钱包操作类账单不传）
     * @type {number}
     * @memberof BillCreateReqVo
     */
    warehouseId?: number;
    /**
     * 退款金额（未传时默认为0）
     * @type {number}
     * @memberof BillCreateReqVo
     */
    returnAmount?: number;
    /**
     * 钱包支付金额（仅billType=4或20时使用）
     * @type {number}
     * @memberof BillCreateReqVo
     */
    walletPay?: number;
    /**
     * 卡支付金额（仅billType=4或20时使用）
     * @type {number}
     * @memberof BillCreateReqVo
     */
    cardPay?: number;
    /**
     * 赠送金支付金额（仅billType=4/20/28退款时使用）
     * @type {number}
     * @memberof BillCreateReqVo
     */
    bonusPay?: number;
    /**
     * 回退积分数（仅退款账单支付记录使用）
     * @type {number}
     * @memberof BillCreateReqVo
     */
    pointsPay?: number;
    /**
     * 回退优惠券列表（仅billType=28退款时使用；后端落库前统一替换billId为退款账单id）
     * @type {Array<CouponPayItem>}
     * @memberof BillCreateReqVo
     */
    couponPays?: Array<CouponPayItem>;
    /**
     * 代买取消商品列表（仅billType=2代买取消手续费时使用，部分取消时传入）
     * @type {Array<CancelGoodsItem>}
     * @memberof BillCreateReqVo
     */
    cancelGoodsList?: Array<CancelGoodsItem>;
    /**
     * 退货运单号（仅billType=5或11时传入）
     * @type {string}
     * @memberof BillCreateReqVo
     */
    returnCode?: string;
    /**
     * 总箱数（billType=3/7/8/12/23时使用，用于调整运单箱数）
     * @type {number}
     * @memberof BillCreateReqVo
     */
    totalBoxCount?: number;
}

/**
 * Check if a given object implements the BillCreateReqVo interface.
 */
export function instanceOfBillCreateReqVo(value: object): value is BillCreateReqVo {
    if (!('billType' in value) || value['billType'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function BillCreateReqVoFromJSON(json: any): BillCreateReqVo {
    return BillCreateReqVoFromJSONTyped(json, false);
}

export function BillCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'billType': json['billType'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'orderUpdateTime': json['orderUpdateTime'] == null ? undefined : json['orderUpdateTime'],
        'goodsCount': json['goodsCount'] == null ? undefined : json['goodsCount'],
        'orderDataToken': json['orderDataToken'] == null ? undefined : json['orderDataToken'],
        'exchangeRate': json['exchangeRate'] == null ? undefined : json['exchangeRate'],
        'applyUnit': json['applyUnit'] == null ? undefined : json['applyUnit'],
        'applyValue': json['applyValue'] == null ? undefined : json['applyValue'],
        'totalGoodsAmount': json['totalGoodsAmount'] == null ? undefined : json['totalGoodsAmount'],
        'totalAdditionalServiceAmount': json['totalAdditionalServiceAmount'] == null ? undefined : json['totalAdditionalServiceAmount'],
        'totalTransferAmount': json['totalTransferAmount'] == null ? undefined : json['totalTransferAmount'],
        'totalAmount': json['totalAmount'],
        'cardNumber': json['cardNumber'] == null ? undefined : json['cardNumber'],
        'cardType': json['cardType'] == null ? undefined : json['cardType'],
        'currencyCode': json['currencyCode'],
        'userId': json['userId'],
        'status': json['status'],
        'cardBankName': json['cardBankName'] == null ? undefined : json['cardBankName'],
        'cardHolderName': json['cardHolderName'] == null ? undefined : json['cardHolderName'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'createStaffId': json['createStaffId'] == null ? undefined : json['createStaffId'],
        'sendSms': json['sendSms'] == null ? undefined : json['sendSms'],
        'goodsDetailList': json['goodsDetailList'] == null ? undefined : ((json['goodsDetailList'] as Array<any>).map(GoodsDetailFromJSON)),
        'additionalServiceList': json['additionalServiceList'] == null ? undefined : ((json['additionalServiceList'] as Array<any>).map(AdditionalServiceItemFromJSON)),
        'detailContent': json['detailContent'] == null ? undefined : json['detailContent'],
        'targetId': json['targetId'] == null ? undefined : json['targetId'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'returnAmount': json['returnAmount'] == null ? undefined : json['returnAmount'],
        'walletPay': json['walletPay'] == null ? undefined : json['walletPay'],
        'cardPay': json['cardPay'] == null ? undefined : json['cardPay'],
        'bonusPay': json['bonusPay'] == null ? undefined : json['bonusPay'],
        'pointsPay': json['pointsPay'] == null ? undefined : json['pointsPay'],
        'couponPays': json['couponPays'] == null ? undefined : ((json['couponPays'] as Array<any>).map(CouponPayItemFromJSON)),
        'cancelGoodsList': json['cancelGoodsList'] == null ? undefined : ((json['cancelGoodsList'] as Array<any>).map(CancelGoodsItemFromJSON)),
        'returnCode': json['returnCode'] == null ? undefined : json['returnCode'],
        'totalBoxCount': json['totalBoxCount'] == null ? undefined : json['totalBoxCount'],
    };
}

export function BillCreateReqVoToJSON(json: any): BillCreateReqVo {
    return BillCreateReqVoToJSONTyped(json, false);
}

export function BillCreateReqVoToJSONTyped(value?: BillCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billType': value['billType'],
        'orderCode': value['orderCode'],
        'orderStatus': value['orderStatus'],
        'orderUpdateTime': value['orderUpdateTime'],
        'goodsCount': value['goodsCount'],
        'orderDataToken': value['orderDataToken'],
        'exchangeRate': value['exchangeRate'],
        'applyUnit': value['applyUnit'],
        'applyValue': value['applyValue'],
        'totalGoodsAmount': value['totalGoodsAmount'],
        'totalAdditionalServiceAmount': value['totalAdditionalServiceAmount'],
        'totalTransferAmount': value['totalTransferAmount'],
        'totalAmount': value['totalAmount'],
        'cardNumber': value['cardNumber'],
        'cardType': value['cardType'],
        'currencyCode': value['currencyCode'],
        'userId': value['userId'],
        'status': value['status'],
        'cardBankName': value['cardBankName'],
        'cardHolderName': value['cardHolderName'],
        'remark': value['remark'],
        'createStaffId': value['createStaffId'],
        'sendSms': value['sendSms'],
        'goodsDetailList': value['goodsDetailList'] == null ? undefined : ((value['goodsDetailList'] as Array<any>).map(GoodsDetailToJSON)),
        'additionalServiceList': value['additionalServiceList'] == null ? undefined : ((value['additionalServiceList'] as Array<any>).map(AdditionalServiceItemToJSON)),
        'detailContent': value['detailContent'],
        'targetId': value['targetId'],
        'warehouseId': value['warehouseId'],
        'returnAmount': value['returnAmount'],
        'walletPay': value['walletPay'],
        'cardPay': value['cardPay'],
        'bonusPay': value['bonusPay'],
        'pointsPay': value['pointsPay'],
        'couponPays': value['couponPays'] == null ? undefined : ((value['couponPays'] as Array<any>).map(CouponPayItemToJSON)),
        'cancelGoodsList': value['cancelGoodsList'] == null ? undefined : ((value['cancelGoodsList'] as Array<any>).map(CancelGoodsItemToJSON)),
        'returnCode': value['returnCode'],
        'totalBoxCount': value['totalBoxCount'],
    };
}

